import React, { useEffect, useState } from 'react';

import CustomModal from "../../components/Modal/CustomModal";
import { DelDiasIsc } from "../../funciones/PreferenciasAdminFunction";

const DiasInscTable = (props) => {
    const [openDel, setOpenDel] = useState(false);
    const [boton, setBoton1] = useState({ icon: "fa fa-trash", text: "Eliminar este registro" });
    const [modaldelBtn, setModaldelBtn] = useState({ icon: "fa fa-check", text: "Si", disabled: false });

    let contenidoModal = () => (
        <React.Fragment>
            <div>¿Deseas eliminar la fecha <strong className="text-danger">{props.datos.dia}</strong> de la lista de Dias de Inscripción?</div>
            <div className="text-muted" style={{fontSize: 11}}>Esta opción no puede deshacerse</div>
        </React.Fragment>
    )

    let borrar = () => {
        if (modaldelBtn.disabled === true) return null;
        setModaldelBtn({icon: "fa fa-spinner fa-spin", text: "Espera", disabled: true})
        
        DelDiasIsc (props.datos.id, () => {
            props.delResp()
            setOpenDel(false)
            setModaldelBtn({ icon: "fa fa-check", text: "Si", disabled: false })
        })
    }

    let modalDelete = () => {
        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modaldelBtn.icon}></i> {modaldelBtn.text}</React.Fragment>}
                large = "medium"
                isopen =  {openDel}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Confirmación</div>}
                contenido = {contenidoModal()}      
                funcion1 = {borrar}
                funcion2 = {() => {setOpenDel(false)}}
            />
        );
    }

    return (
        <React.Fragment>
            <tr>
                <td align="center" style={{padding: 2, fontSize: 12}}>{props.datos.dia}</td>
                <td width="70%" style={{padding: 2, fontSize: 10}}>{props.datos.corte}</td>
                <td width="70px" align="center" style={{padding: 2, fontSize: 12}}>
                    <button className="btn btn-danger" onClick={() => { setOpenDel(true) }} style={{borderWidth: 1}} title={boton.text}><i className={boton.icon}></i></button>
                </td>
            </tr>
            {modalDelete()}
        </React.Fragment>
    );
}

export default DiasInscTable;


// WEBPACK FOOTER //
// ./src/views/Opciones/DiasInscTable.jsx